import { take, put, select, takeLatest, call } from 'redux-saga/effects';
import get from 'lodash/get';

import * as scheduleSearch from '../requests/schedule-search-req';
import * as workslotInsert from '../requests/workslot-insert-req';
import * as workslotRemove from '../requests/workslot-remove-req';
import * as workslotUpdate from '../requests/workslot-update-req';
import * as blockslotInsert from '../requests/blockslot-insert-req';
import * as blockslotRemove from '../requests/blockslot-remove-req';
import * as blockslotUpdate from '../requests/blockslot-update-req';
import { SCHEDULE_FILTER_TYPES, scheduleFilterActions } from '../filter';
import {
  selectScheduleDateRange,
  selectSchedulePopoverData,
  selectScheduleTargerProviderId,
} from '../selectors';
import { calculateOffsetTop } from '../../../utils/schedule/offset-calculation';
import {
  emitClearSelectionEvent,
  emitInitSceduleLoadEvent,
} from '../../../utils/schedule/events';

function* handleInitScheduleLoad() {
  yield call(loadScheduleSearchSlots);
  const { payload } = yield take(scheduleSearch.consts.SUCCEED);
  const data = calculateOffsetTop(payload.workSlots);
  yield call(emitInitSceduleLoadEvent, data);
}

export function* loadScheduleSearchSlots() {
  const id = yield select(selectScheduleTargerProviderId);
  const dateRange = yield select(selectScheduleDateRange);

  yield put(scheduleSearch.actions.send({ id, ...dateRange }));
}

function* handleRemoveInsertion() {
  yield call(emitClearSelectionEvent);
  yield call(loadScheduleSearchSlots);
}

function* clearSelection() {
  yield call(emitClearSelectionEvent);
}

const payloadType = {
  [workslotInsert.consts.SEND]: {
    key: 'workSlot',
    succeed: workslotInsert.consts.SUCCEED,
  },
  [blockslotInsert.consts.SEND]: {
    key: 'blockedSlot',
    succeed: blockslotInsert.consts.SUCCEED,
  },
};

function* handleNewInsertion({ type, payload }) {
  const selectedSchedule = yield select(selectSchedulePopoverData);
  const { key, succeed } = payloadType[type];
  const { scheduleSettingAttributes } = payload[key];
  const isRepeatable = get(selectedSchedule, 'isRepeatable');
  const activeDate = get(selectedSchedule, 'activeDate');
  let { startOn } = scheduleSettingAttributes;

  if (isRepeatable) {
    startOn = activeDate;
  }

  yield take(succeed);
  yield put(scheduleFilterActions.setDate(startOn));
  yield call(emitClearSelectionEvent);
}

export default function* fetchScheduleSaga() {
  yield takeLatest([scheduleSearch.consts.SUCCEED], clearSelection);
  yield takeLatest([scheduleSearch.consts.INIT_LOAD], handleInitScheduleLoad);
  yield takeLatest(
    [
      SCHEDULE_FILTER_TYPES.NEXT_WEEK,
      SCHEDULE_FILTER_TYPES.PREV_WEEK,
      SCHEDULE_FILTER_TYPES.SET_DATE,
    ],
    loadScheduleSearchSlots,
  );

  yield takeLatest(
    [workslotInsert.consts.SEND, blockslotInsert.consts.SEND],
    handleNewInsertion,
  );
  yield takeLatest(
    [
      workslotRemove.consts.SUCCEED,
      blockslotRemove.consts.SUCCEED,
      workslotUpdate.consts.SUCCEED,
      blockslotUpdate.consts.SUCCEED,
    ],
    handleRemoveInsertion,
  );
}



// WEBPACK FOOTER //
// ./src/redux/schedule/sagas/fetch-schedule-saga.js